import React, { memo } from "react";

import { ShowcaseCard, ShowcaseNotice } from "ui/components/Showcase";

import { VehicleWizardSceneProps } from "../types";
import CheckIcon from "./CheckIcon";

const LOCATIONS = [
  { name: "Poslovnica Zagreb", address: "Radnička cesta 80", isSelected: true },
  { name: "Skladište Sesvete", address: "Ljudevita Posavskog 12", isSelected: false },
  { name: "Poslovnica Split", address: "Put Supavla 21", isSelected: false },
];

/** Korak "Lokacija": karta s oznakom, popis poslovnica i skladišta te vozilo na lokaciji. */
const LocationScene: React.FC<VehicleWizardSceneProps> = ({ vehicleInfo }) => {
  return (
    <>
      <ShowcaseCard className="left-[0.5rem] top-[-1rem] w-[17rem] h-[18rem]" delay={0}>
        {/* Stilizirana karta: blokovi, ceste i oznaka lokacije. */}
        <div className="relative h-[12.6rem] rounded-t-lg bg-sky-50 overflow-hidden">
          <div className="absolute inset-x-0 top-[45%] h-3 bg-white" />
          <div className="absolute inset-y-0 left-[38%] w-3 bg-white" />
          <div className="absolute inset-y-0 left-[72%] w-2 bg-white rotate-12" />
          <div className="absolute top-3 left-3 w-16 h-10 rounded-sm bg-emerald-100" />
          <div className="absolute bottom-3 left-6 w-20 h-8 rounded-sm bg-slate-200/70" />
          <div className="absolute top-4 right-4 w-14 h-12 rounded-sm bg-slate-200/70" />
          <div className="absolute bottom-4 right-6 w-12 h-8 rounded-sm bg-amber-100" />
          <div className="absolute left-[38%] top-[45%] -translate-x-1/3 -translate-y-full">
            <svg className="w-9 h-9 drop-shadow-lg" viewBox="0 0 24 24" aria-hidden="true">
              <path d="M12 2a7 7 0 00-7 7c0 5 7 13 7 13s7-8 7-13a7 7 0 00-7-7z" fill="#2563EB" />
              <circle cx="12" cy="9" r="2.5" fill="#fff" />
            </svg>
          </div>
        </div>
        <div className="p-5">
          <div className="text-sm font-bold text-slate-800">Poslovnica Zagreb</div>
          <div className="mt-1 text-[0.7rem] text-slate-400">Radnička cesta 80, 10000 Zagreb</div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="right-[-0.5rem] top-[6rem] w-[14rem]" delay={0.25}>
        <div className="p-5">
          <div className="text-xs font-bold text-slate-800">Poslovnice i skladišta</div>
          <div className="mt-3 space-y-2.5">
            {LOCATIONS.map((location) => (
              <div key={location.name} className="flex items-center gap-2">
                {location.isSelected ? (
                  <CheckIcon />
                ) : (
                  <span className="w-5 h-5 rounded-full border-2 border-slate-200 flex-shrink-0" />
                )}
                <div className="min-w-0">
                  <div className="text-[0.7rem] font-semibold text-slate-700 truncate">{location.name}</div>
                  <div className="text-[0.6rem] text-slate-400 truncate">{location.address}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </ShowcaseCard>

      <ShowcaseCard className="left-[-1.5rem] bottom-[-0.5rem] w-[15rem]" delay={0.5}>
        <ShowcaseNotice
          title="Uvijek znate gdje je vozilo"
          subtitle="Premještaj bilježi novu lokaciju"
          iconClassName="bg-blue-100"
          icon={
            <svg className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="#1D4ED8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M12 2a7 7 0 00-7 7c0 5 7 13 7 13s7-8 7-13a7 7 0 00-7-7zM12 11.5a2.5 2.5 0 100-5 2.5 2.5 0 000 5z" />
            </svg>
          }
        />
      </ShowcaseCard>
    </>
  );
};

export default memo(LocationScene);
